module.exports = __webpack_public_path__ + "img/banner_ls_m.0fc661da.png";